require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/fn/object/assign.js
// module id = 279
// module chunks = 16